import { render, staticRenderFns } from "./TablaResiduosComponent.vue?vue&type=template&id=eebe126c&scoped=true&"
import script from "./TablaResiduosComponent.vue?vue&type=script&lang=js&"
export * from "./TablaResiduosComponent.vue?vue&type=script&lang=js&"
import style0 from "./TablaResiduosComponent.vue?vue&type=style&index=0&id=eebe126c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebe126c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VDataTable,VEditDialog,VLayout,VListItem,VListItemContent,VListItemSubtitle,VSheet,VTextField})
